import React, { useEffect, useRef } from "react";
import { Route, Routes } from "react-router-dom";
// prettier-ignore
import { app } from "./config/firebase.config";
import { getAuth } from "firebase/auth";
import { validateLogin } from "./api";
// prettier-ignore
import { useStateValue } from "./context/StateProvider";
import { actionType } from "./context/reducer";
// prettier-ignore
import {Dashboard,Favourites,Home,Login,MainLoader,UserProfile,VideoDetail,} from "./Components";
import Alert from "./Components/Alert/Alert";

import { motion } from "framer-motion";

import { fadeInOut } from "./utils/animations";

const App = () => {
  const firebaseAuth = getAuth(app);
  const [{ user, mainLoader, alertState }, dispatch] = useStateValue();
  const effectRun = useRef();

  useEffect(() => {
    // if (effectRun.current === true) {
    console.log("Mount");
    dispatch({
      type: actionType.SET_MAIN_LOADER,
      mainLoader: true,
    });

    firebaseAuth.onAuthStateChanged((userCred) => {
      if (userCred) {
        userCred.getIdToken().then((token) => {
          validateLogin(token).then((data) => {
            dispatch({
              type: actionType.SET_USER,
              user: data.data,
            });
          });
        });
      } else {
        dispatch({
          type: actionType.SET_USER,
          user: null,
        });
      }

      setTimeout(() => {
        dispatch({
          type: actionType.SET_MAIN_LOADER,
          mainLoader: false,
        });
      }, 3000);
    });
    // }
    return () => {
      console.log("unmount");
      // effectRun.current = true;
    };
  }, []);

  return (
    <div className="w-full h-auto flex flex-col justify-center items-center">
      {/* Main Loader */}
      {mainLoader && (
        <motion.div
          {...fadeInOut}
          className="fixed z-50 inset-0 bg-lightOverlay backdrop-blur-md flex items-center justify-center w-full "
        >
          <MainLoader />
        </motion.div>
      )}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<Home />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
        <Route path="/userProfile/:uid" element={<UserProfile />} />
        <Route path="/favourites/:uid" element={<Favourites />} />
        <Route path="/videoDetail/:concept_id" element={<VideoDetail />} />
      </Routes>

      {alertState && <Alert />}
    </div>
  );
};

export default App;
